<template>
  <div class="_35lz77bA">
    <div class="_1SI39Ofv" v-if="show">
      <div class="_9-ZpLxb0">
        <img
          src="data:image/png;base64,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"
          alt="icon"
        />
        <div class="_3_qzGcRD"><span class="_1N8mCmac">-</span><span>B</span><span>O</span><span>B</span><span>.</span><span>C</span><span>O</span><span>M</span><span class="_1N8mCmac">-</span></div>
      </div>
    </div>
    <div class="_24vddGqv">
      <div class="wjHkeryU">
        <div class="_29gnuiyG animated fadeInUp" style="margin: 82px auto 71px">
          <div class="_35_vygsc">
            <h1 style="margin-top: -23px">体育投注</h1>
            <h2>SPORTS EVENT</h2>
          </div>
          <!-- <div class="_2zJiZW9W">
            <div class="_349CzCYy xJQe3jRu _3gi7jqcw _12ZkQT2g" style="padding: 0px"><img class="_2JoosS9F" src="/static/image/sbty.png" alt="" /><img class="_2JoosS9F hover" src="/static/image/sbty_hover.png" alt="" /><span>沙巴体育</span></div>
            <div class="_349CzCYy xJQe3jRu _3gi7jqcw" style="padding: 0px"><img class="_2JoosS9F" src="/static/image/ssty.png" alt="" /><img class="_2JoosS9F hover" src="/static/image/ssty_hover.png" alt="" /><span>三昇体育</span></div>
            <div class="_349CzCYy xJQe3jRu _3gi7jqcw" style="padding: 0px"><img class="_2JoosS9F" src="/static/image/cmd.png" alt="" /><img class="_2JoosS9F hover" src="/static/image/cmd_hover.png" alt="" /><span>CMD体育</span></div>
            <div class="_349CzCYy xJQe3jRu _3gi7jqcw" style="padding: 0px"><img class="_2JoosS9F" src="/static/image/asia.png" alt="" /><img class="_2JoosS9F hover" src="/static/image/asia_hover.png" alt="" /><span>ASIA体育</span></div>
            <div class="_349CzCYy xJQe3jRu _3gi7jqcw" style="padding: 0px"><img class="_2JoosS9F" src="/static/image/tg.png" alt="" /><img class="_2JoosS9F hover" src="/static/image/tg_hover.png" alt="" /><span>TG体育</span></div>
            <div class="_349CzCYy xJQe3jRu _3gi7jqcw" style="padding: 0px"><img class="_2JoosS9F" src="/static/image/sbo.png" alt="" /><img class="_2JoosS9F hover" src="/static/image/sbo_hover.png" alt="" /><span>SBO体育</span></div>
            <div class="_349CzCYy xJQe3jRu _3gi7jqcw" style="padding: 0px"><img class="_2JoosS9F" src="/static/image/ob.png" alt="" /><img class="_2JoosS9F hover" src="/static/image/ob-hover.png" alt="" /><span>OB体育</span></div>
            <div class="_349CzCYy xJQe3jRu _3gi7jqcw" style="padding: 0px"><img class="_2JoosS9F" src="/static/image/bbin.png" alt="" /><img class="_2JoosS9F hover" src="/static/image/bbin_hover.png" alt="" /><span>BBIN体育</span></div>
          </div> -->
          <div class="_2zJiZW9W">
            <div @click="changplatform_name(item.platform_name)" :class="platform_name == item.platform_name ? '_349CzCYy xJQe3jRu _3gi7jqcw _12ZkQT2g' : '_349CzCYy xJQe3jRu _3gi7jqcw'" v-for="(item, index) in gameList" :key="index" v-if="item.app_state == 1" style="padding: 0px">
              <img class="_2JoosS9F"  v-if="imgList[item.platform_name]" :src="imgList[item.platform_name]['img']" alt="" /><img  v-if="imgList[item.platform_name]" class="_2JoosS9F hover" :src="imgList[item.platform_name]['hover']" alt="" /><span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="h851vWpX" v-for="(item, index) in gameList" :key="index" v-if=" item.platform_name == platform_name" >
          <div class="_1UE-ldYw"><img  v-if="imgList[item.platform_name]" :src="imgList[item.platform_name]['title']" class="oZtthmYX" /><img class="_3KAiUPJ2" src="/static/image/pic1.png" /></div>
          <div class="_3bdNR9wu">
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>玩法多样 优质体验</div>
                <div class="_1unX-k3M">体育赛事全覆盖，一场比赛百种玩法，操作简单，满足新老用户体验</div>
              </div>
            </div>
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>特殊赛事 感受激情</div>
                <div class="_1unX-k3M">特殊盘口、15分钟让球，大/小、独赢等独特玩法，让您时刻享受激情</div>
              </div>
            </div>
            <img class="B2lGJAHD" src="/static/image/sport_er_img_ob-2ffd.png" />
            <div class="_2LINmtV0">
              <div v-if="item.app_state == 1" class="_349CzCYy xJQe3jRu _hPM8cbq" @click="goGamePage(item.platform_name, item.game_code , '')" style="border-radius: 25vh"><span>立即投注</span></div>
              <div v-else class="_349CzCYy xJQe3jRu _hPM8cbq" style="border-radius: 25vh"><span>维护中</span></div>
            
            </div>
          </div>
          <div class="_3efekQzm">
            <img class="_1daGKxbJ _2x8Pq0NA" src="/static/image/ej_logo_xj_sele-c102.png" /><img class="_1daGKxbJ ls-is-cached" src="/static/image/ej_logo_xj_unsele-3def.png" data-src="/static/image/ej_logo_xj_unsele-3def.png" />
            <div class="_1gXTPMRQ"><img class="_2vyEl2F2 ls-is-cached" src="/static/image/img_soccer_player-a7f1.png" /></div>
            <img class="_3g2fFXQz _3mdBM6t-" src="/static/image/pic2.png" /><img class="_1T-KBsyv _3mdBM6t-" src="/static/image/pic4.png" />
          </div>
        </div>
        <!-- 巴沙 -->
        <div class="h851vWpX" style="display: none">
          <div class="_1UE-ldYw"><img src="/static/image/img_saba_title.png" class="oZtthmYX" /><img class="_3KAiUPJ2" src="/static/image/pic1.png" /></div>
          <div class="_3bdNR9wu">
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>玩法多样 优质体验</div>
                <div class="_1unX-k3M">体育赛事全覆盖，一场比赛百种玩法，操作简单，满足新老用户体验</div>
              </div>
            </div>
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>特殊赛事 感受激情</div>
                <div class="_1unX-k3M">特殊盘口、15分钟让球，大/小、独赢等独特玩法，让您时刻享受激情</div>
              </div>
            </div>
            <img class="B2lGJAHD" src="/static/image/sport_er_img_ob-2ffd.png" />
            <div class="_2LINmtV0">
              <div class="_349CzCYy xJQe3jRu _hPM8cbq" @click="goGamePage('sbtest', '2', '')" style="border-radius: 25vh"><span>立即投注</span></div>
              <!-- <div class="_349CzCYy xJQe3jRu _hPM8cbq" style="border-radius: 25vh"><span>新手帮助</span></div> -->
            </div>
          </div>
          <div class="_3efekQzm">
            <img class="_1daGKxbJ _2x8Pq0NA" src="/static/image/ej_logo_xj_sele-c102.png" /><img class="_1daGKxbJ ls-is-cached" src="/static/image/ej_logo_xj_unsele-3def.png" data-src="/static/image/ej_logo_xj_unsele-3def.png" />
            <div class="_1gXTPMRQ"><img class="_2vyEl2F2 ls-is-cached" src="/static/image/img_soccer_player-a7f1.png" /></div>
            <img class="_3g2fFXQz _3mdBM6t-" src="/static/image/pic2.png" /><img class="_1T-KBsyv _3mdBM6t-" src="/static/image/pic4.png" />
          </div>
        </div>
        <!-- 三生 -->
        <div class="h851vWpX" style="display: none">
          <div class="_1UE-ldYw"><img src="/static/image/img_ss_title.png" class="oZtthmYX" /><img class="_3KAiUPJ2" src="/static/image/pic1.png" /></div>
          <div class="_3bdNR9wu">
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>崭新玩法 感受精彩</div>
                <div class="_1unX-k3M">丰富的体育赛事一应俱全，项目玩法多元，下半场波胆、让球崭新玩法，感受不一样的精彩</div>
              </div>
            </div>
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>提前兑现 及时止损</div>
                <div class="_1unX-k3M">创新功能提前兑现，无需等待即可提前结算，止损机制让您百无禁忌</div>
              </div>
            </div>
            <img class="B2lGJAHD" src="/static/image/img_imsport_icons-70c9.png" />
            <div class="_2LINmtV0">
              <div class="_349CzCYy xJQe3jRu _hPM8cbq" @click="goGamePage('oap', '2', '')" style="border-radius: 25vh"><span>立即投注</span></div>
            </div>
          </div>
          <div class="_3efekQzm">
            <img class="_1daGKxbJ _2x8Pq0NA" src="/static/image/bg_bob_02-bda0.png" /><img class="_1daGKxbJ ls-is-cached" src="/static/image/bg_bob_01-596e.png" />
            <div class="_1gXTPMRQ"><img class="_2vyEl2F2 ls-is-cached" src="/static/image/img_basketball_player-cec7.png" /></div>
            <img class="_3g2fFXQz _3mdBM6t-" src="/static/image/pic2.png" /><img class="_1T-KBsyv _3mdBM6t-" src="/static/image/pic3.png" />
          </div>
        </div>
        <!-- cmd -->
        <div class="h851vWpX" style="display: none">
          <div class="_1UE-ldYw"><img src="/static/image/img_cmd_title.png" class="oZtthmYX" /><img class="_3KAiUPJ2" src="/static/image/pic1.png" /></div>
          <div class="_3bdNR9wu">
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>提前兑换 心跳投注</div>
                <div class="_1unX-k3M">当机立断提前跳车，丝滑流程先行收米；滚球投注秒速级确认，精彩刺激媲美娱乐场</div>
              </div>
            </div>
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>最全赛事 实时结算</div>
                <div class="_1unX-k3M">32+运动类型覆盖，每月超5000场赛事；强力结算引擎实时扫描，完美优化投注体验</div>
              </div>
            </div>
            <img class="B2lGJAHD" src="/static/image/sport_er_img_fb-21be.png" />
            <div class="_2LINmtV0">
              <div class="_349CzCYy xJQe3jRu _hPM8cbq" @click="goGamePage('cmd', '2', '')" style="border-radius: 25vh"><span>立即投注</span></div>
              <!-- <div class="_349CzCYy xJQe3jRu _hPM8cbq" style="border-radius: 25vh"><span>新手帮助</span></div> -->
            </div>
          </div>
          <div class="_3efekQzm">
            <img class="_1daGKxbJ _2x8Pq0NA" src="/static/image/sport_ej_logo_fb_sele-86d0.png" /><img class="_1daGKxbJ ls-is-cached" src="/static/image/sport_ej_logo_fb_unsele-a775.png" data-src="/static/image/sport_ej_logo_fb_unsele-a775.png" />
            <div class="_1gXTPMRQ"><img class="_2vyEl2F2 ls-is-cached" src="/static/image/sport_ej_img_fb-faf7.png" /></div>
            <img class="_3g2fFXQz _3mdBM6t-" src="/static/image/pic5.png" /><img class="_1T-KBsyv _3mdBM6t-" src="/static/image/pic6.png" />
          </div>
        </div>
        <!-- ASIA -->
        <div class="h851vWpX" style="display: none">
          <div class="_1UE-ldYw"><img src="/static/image/img_asia_title.png" class="oZtthmYX" /><img class="_3KAiUPJ2" src="/static/image/pic1.png" /></div>
          <div class="_3bdNR9wu">
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>崭新玩法 感受精彩</div>
                <div class="_1unX-k3M">丰富的体育赛事一应俱全，项目玩法多元，下半场波胆、让球崭新玩法，感受不一样的精彩</div>
              </div>
            </div>
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>提前兑现 及时止损</div>
                <div class="_1unX-k3M">创新功能提前兑现，无需等待即可提前结算，止损机制让您百无禁忌</div>
              </div>
            </div>
            <img class="B2lGJAHD" src="/static/image/img_imsport_icons-70c9.png" />
            <div class="_2LINmtV0">
              <div class="_349CzCYy xJQe3jRu _hPM8cbq" @click="goGamePage('hbb', '2', '')" style="border-radius: 25vh"><span>立即投注</span></div>
            </div>
          </div>
          <div class="_3efekQzm">
            <img class="_1daGKxbJ _2x8Pq0NA" src="/static/image/bg_bob_02-bda0.png" /><img class="_1daGKxbJ ls-is-cached" src="/static/image/bg_bob_01-596e.png" />
            <div class="_1gXTPMRQ"><img class="_2vyEl2F2 ls-is-cached" src="/static/image/img_basketball_player-cec7.png" /></div>
            <img class="_3g2fFXQz _3mdBM6t-" src="/static/image/pic2.png" /><img class="_1T-KBsyv _3mdBM6t-" src="/static/image/pic3.png" />
          </div>
        </div>
        <!-- TG -->
        <div class="h851vWpX" style="display: none">
          <div class="_1UE-ldYw"><img src="/static/image/img_tgty_title.png" class="oZtthmYX" /><img class="_3KAiUPJ2" src="/static/image/pic1.png" /></div>
          <div class="_3bdNR9wu">
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>玩法多样 优质体验</div>
                <div class="_1unX-k3M">体育赛事全覆盖，一场比赛百种玩法，操作简单，满足新老用户体验</div>
              </div>
            </div>
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>特殊赛事 感受激情</div>
                <div class="_1unX-k3M">特殊盘口、15分钟让球，大/小、独赢等独特玩法，让您时刻享受激情</div>
              </div>
            </div>
            <img class="B2lGJAHD" src="/static/image/sport_er_img_ob-2ffd.png" />
            <div class="_2LINmtV0">
              <div class="_349CzCYy xJQe3jRu _hPM8cbq" @click="goGamePage('saba', '2', '')" style="border-radius: 25vh"><span>立即投注</span></div>
              <!-- <div class="_349CzCYy xJQe3jRu _hPM8cbq" style="border-radius: 25vh"><span>新手帮助</span></div> -->
            </div>
          </div>
          <div class="_3efekQzm">
            <img class="_1daGKxbJ _2x8Pq0NA" src="/static/image/ej_logo_xj_sele-c102.png" /><img class="_1daGKxbJ ls-is-cached" src="/static/image/ej_logo_xj_unsele-3def.png" data-src="/static/image/ej_logo_xj_unsele-3def.png" />
            <div class="_1gXTPMRQ"><img class="_2vyEl2F2 ls-is-cached" src="/static/image/img_soccer_player-a7f1.png" /></div>
            <img class="_3g2fFXQz _3mdBM6t-" src="/static/image/pic2.png" /><img class="_1T-KBsyv _3mdBM6t-" src="/static/image/pic4.png" />
          </div>
        </div>
        <!-- SBD -->
        <div class="h851vWpX" style="display: none">
          <div class="_1UE-ldYw"><img src="/static/image/img_sbo_title.png" class="oZtthmYX" /><img class="_3KAiUPJ2" src="/static/image/pic1.png" /></div>
          <div class="_3bdNR9wu">
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>提前兑换 心跳投注</div>
                <div class="_1unX-k3M">当机立断提前跳车，丝滑流程先行收米；滚球投注秒速级确认，精彩刺激媲美娱乐场</div>
              </div>
            </div>
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>最全赛事 实时结算</div>
                <div class="_1unX-k3M">32+运动类型覆盖，每月超5000场赛事；强力结算引擎实时扫描，完美优化投注体验</div>
              </div>
            </div>
            <img class="B2lGJAHD" src="/static/image/sport_er_img_fb-21be.png" />
            <div class="_2LINmtV0">
              <div class="_349CzCYy xJQe3jRu _hPM8cbq" @click="goGamePage('xsbo', '2', '')" style="border-radius: 25vh"><span>立即投注</span></div>
              <!-- <div class="_349CzCYy xJQe3jRu _hPM8cbq" style="border-radius: 25vh"><span>新手帮助</span></div> -->
            </div>
          </div>
          <div class="_3efekQzm">
            <img class="_1daGKxbJ _2x8Pq0NA" src="/static/image/sport_ej_logo_fb_sele-86d0.png" /><img class="_1daGKxbJ ls-is-cached" src="/static/image/sport_ej_logo_fb_unsele-a775.png" data-src="/static/image/sport_ej_logo_fb_unsele-a775.png" />
            <div class="_1gXTPMRQ"><img class="_2vyEl2F2 ls-is-cached" src="/static/image/sport_ej_img_fb-faf7.png" /></div>
            <img class="_3g2fFXQz _3mdBM6t-" src="/static/image/pic5.png" /><img class="_1T-KBsyv _3mdBM6t-" src="/static/image/pic6.png" />
          </div>
        </div>
        <!-- OB -->
        <div class="h851vWpX" style="display: none">
          <div class="_1UE-ldYw"><img src="/static/image/img_obty_title.png" class="oZtthmYX" /><img class="_3KAiUPJ2" src="/static/image/pic1.png" /></div>
          <div class="_3bdNR9wu">
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>崭新玩法 感受精彩</div>
                <div class="_1unX-k3M">丰富的体育赛事一应俱全，项目玩法多元，下半场波胆、让球崭新玩法，感受不一样的精彩</div>
              </div>
            </div>
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>提前兑现 及时止损</div>
                <div class="_1unX-k3M">创新功能提前兑现，无需等待即可提前结算，止损机制让您百无禁忌</div>
              </div>
            </div>
            <img class="B2lGJAHD" src="/static/image/img_imsport_icons-70c9.png" />
            <div class="_2LINmtV0">
              <div class="_349CzCYy xJQe3jRu _hPM8cbq" @click="goGamePage('obgty', '2', '')" style="border-radius: 25vh"><span>立即投注</span></div>
            </div>
          </div>
          <div class="_3efekQzm">
            <img class="_1daGKxbJ _2x8Pq0NA" src="/static/image/bg_bob_02-bda0.png" /><img class="_1daGKxbJ ls-is-cached" src="/static/image/bg_bob_01-596e.png" />
            <div class="_1gXTPMRQ"><img class="_2vyEl2F2 ls-is-cached" src="/static/image/img_basketball_player-cec7.png" /></div>
            <img class="_3g2fFXQz _3mdBM6t-" src="/static/image/pic2.png" /><img class="_1T-KBsyv _3mdBM6t-" src="/static/image/pic3.png" />
          </div>
        </div>
        <!-- BBIN -->

        <div class="h851vWpX" style="display: none">
          <div class="_1UE-ldYw"><img src="/static/image/img_bbinty_title.png" class="oZtthmYX" /><img class="_3KAiUPJ2" src="/static/image/pic1.png" /></div>
          <div class="_3bdNR9wu">
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>玩法多样 优质体验</div>
                <div class="_1unX-k3M">体育赛事全覆盖，一场比赛百种玩法，操作简单，满足新老用户体验</div>
              </div>
            </div>
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>特殊赛事 感受激情</div>
                <div class="_1unX-k3M">特殊盘口、15分钟让球，大/小、独赢等独特玩法，让您时刻享受激情</div>
              </div>
            </div>
            <img class="B2lGJAHD" src="/static/image/sport_er_img_ob-2ffd.png" />
            <div class="_2LINmtV0">
              <div class="_349CzCYy xJQe3jRu _hPM8cbq" @click="goGamePage('bbin', 'bbinpe', '')" style="border-radius: 25vh"><span>立即投注</span></div>
              <!-- <div class="_349CzCYy xJQe3jRu _hPM8cbq" style="border-radius: 25vh"><span>新手帮助</span></div> -->
            </div>
          </div>
          <div class="_3efekQzm">
            <img class="_1daGKxbJ _2x8Pq0NA" src="/static/image/ej_logo_xj_sele-c102.png" /><img class="_1daGKxbJ ls-is-cached" src="/static/image/ej_logo_xj_unsele-3def.png" data-src="/static/image/ej_logo_xj_unsele-3def.png" />
            <div class="_1gXTPMRQ"><img class="_2vyEl2F2 ls-is-cached" src="/static/image/img_soccer_player-a7f1.png" /></div>
            <img class="_3g2fFXQz _3mdBM6t-" src="/static/image/pic2.png" /><img class="_1T-KBsyv _3mdBM6t-" src="/static/image/pic4.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sports',
  data() {
    return {
      jumpUrl: null,
      gameList: [],
      show: false,
      platform_name: '',
      imgList:{
            sbtest: { img: '/static/image/sbty.png', hover: '/static/image/sbty_hover.png', title: '/static/image/img_saba_title.png' },
      oap: { img: '/static/image/ssty.png', hover: '/static/image/ssty_hover.png', title: '/static/image/img_ss_title.png' },
      cmd: { img: '/static/image/cmd.png', hover: '/static/image/cmd_hover.png', title: '/static/image/img_cmd_title.png' },
      hbb: { img: '/static/image/asia.png', hover: '/static/image/asia_hover.png', title: '/static/image/img_asia_title.png' },
      saba: { img: '/static/image/tg.png', hover: '/static/image/tg_hover.png', title: '/static/image/img_tgty_title.png' },
      xsbo: { img: '/static/image/sbo.png', hover: '/static/image/sbo_hover.png', title: '/static/image/img_sbo_title.png' },
      obgty: { img: '/static/image/ob.png', hover: '/static/image/ob-hover.png', title: '/static/image/img_obty_title.png' },
      bbin: { img: '/static/image/bbin.png', hover: '/static/image/bbin_hover.png', title: '/static/image/img_bbinty_title.png' },
      }
    };
  },
  created() {
    let that = this;
    that.getGameList();
  },
  methods: {
    changplatform_name(val) {
      this.platform_name = val;
    },
    getGameList() {
      let that = this;
      that.show = true;
      that.$apiFun.get('/api/game/list', { category: 'sport' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
          that.show = false;
          let arr = that.gameList;
          for (let i in arr) {
            if (arr[i]['app_state'] == 1) {
              that.platform_name = arr[i]['platform_name'];
              return;
            }
          }
        }
      });
    },
    goGamePage(name, type, code) {
      let p = this.$parent;
      while (p) {
        if (typeof p.openGamePage === 'function') {
          p.openGamePage(name, type, code);
          return;
        }
        p = p.$parent;
      }
    },
    showTost(title) {
      $('body').append(`
            <div class='ant-message' style='top: 400px;'><span><div class='ant-message-notice'><div class='ant-message-notice-content'>
            <div class='ant-message-custom-content ant-message-info'><span role='img' aria-label='info-circle' class='anticon anticon-info-circle'>
            <svg viewBox='64 64 896 896' focusable='false' data-icon='info-circle' width='1em' height='1em' fill='currentColor' aria-hidden='true'>
            <path d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z'></path></svg></span><span>
            ${title}
            </span></div></div></div></span>
            </div>`);
      setTimeout('$(".ant-message").detach()', 2000);
    },
  },
  mounted() {
    //场馆切换
    // $('._2zJiZW9W ._349CzCYy').click(function () {
    //   var index = $(this).index();
    //   $(this).addClass('_12ZkQT2g').siblings().removeClass('_12ZkQT2g');
    //   $('.h851vWpX').eq(index).show().siblings('.h851vWpX').hide();
    // });
    // $('._3efekQzm').hover(
    //   function () {
    //     $(this).find('._3g2fFXQz,._1T-KBsyv').removeClass('_3mdBM6t-');
    //     $(this).find('._1daGKxbJ:not(.ls-is-cached)').removeClass('_2x8Pq0NA');
    //     $(this).find('._2vyEl2F2').css({ transform: 'scale3d(1.05, 1.05, 1.05)', transition: 'all 0.3s' });
    //   },
    //   function () {
    //     $(this).find('._3g2fFXQz,._1T-KBsyv').addClass('_3mdBM6t-');
    //     $(this).find('._1daGKxbJ:not(.ls-is-cached)').addClass('_2x8Pq0NA');
    //     $(this).find('._2vyEl2F2').css('transform', 'scale3d(1, 1, 1)');
    //   },
    // );
    //设置左边界以便内容居中
    autoMargin();
    $(window).resize(function () {
      autoMargin();
    });
    function autoMargin() {
      var Width = $(window).width();
      var Margin = (Width - 1920) / 2 + 'px';
      $('.h851vWpX').css('margin-left', Margin);
    }
  },
  updated() {
    let that = this;
  },
  watch: {
    // 新窗口打开页面，解决浏览器拦截问题
    jumpUrl() {
      if (this.jumpUrl) {
        window.open(this.jumpUrl, '_blank');
      }
      this.jumpUrl = null;
    },
  },
  watch: {
    // 新窗口打开页面，解决浏览器拦截问题
    jumpUrl() {
      if (this.jumpUrl) {
        window.open(this.jumpUrl, '_blank');
      }
      this.jumpUrl = null;
    },
  },
};
</script>
<style lang="scss" scoped>
.fangda {
  animation: _308UEapr 0.5s ease-out;
}
.hover {
  display: none;
}
._3gi7jqcw:hover ._2JoosS9F {
  display: none;
}
._3gi7jqcw:hover .hover {
  display: block;
}
._3gi7jqcw._12ZkQT2g ._2JoosS9F {
  display: none;
}
._3gi7jqcw._12ZkQT2g .hover {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/sports.vue